module.exports = __webpack_public_path__ + "media/images/no_image-fdbb0cc2ae058f5b91ee16a180d50043.png";